// extracted by mini-css-extract-plugin
module.exports = {"head":"Updatabusiness_head__35z8c","title":"Updatabusiness_title__1nqiS","titletext":"Updatabusiness_titletext__Ernn0","content":"Updatabusiness_content__dtRqi"};